import { render } from "./HistoryFault.vue?vue&type=template&id=30bbf554&scoped=true"
import script from "./HistoryFault.vue?vue&type=script&lang=js"
export * from "./HistoryFault.vue?vue&type=script&lang=js"

import "./HistoryFault.vue?vue&type=style&index=0&id=30bbf554&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bbf554"],['__file',"src/views/ProductDiagnosis/components/HistoryFault.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30bbf554"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30bbf554', __exports__)) {
    api.reload('30bbf554', __exports__)
  }
  
  module.hot.accept("./HistoryFault.vue?vue&type=template&id=30bbf554&scoped=true", () => {
    api.rerender('30bbf554', render)
  })

}


export default __exports__